import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  ClearanceActions,
  ClearancesState,
  CRClearanceBody,
  CRClearanceBodyAPI,
  CRClearanceKey,
  CRClearanceSummary,
  CRClearanceSummaryAPI,
} from './types';

type AnyClearance =
  | CRClearanceKey
  | CRClearanceSummary
  | CRClearanceBody
  | undefined;

function sameKeyClearance(a: AnyClearance, b: AnyClearance): boolean {
  return a?.clearanceId === b?.clearanceId;
}

function getEndpointClearance(key: AnyClearance): string {
  return key ? `/clearances/${key.clearanceId}/` : '/clearances/';
}

function parseClearanceSummary(
  clearanceSummary: CRClearanceSummaryAPI,
): CRClearanceSummary {
  return clearanceSummary;
}

function parseClearanceBody(
  clearanceDetail: CRClearanceBodyAPI,
): CRClearanceBody {
  return clearanceDetail;
}

const clearancesStateSelector = (state: any): ClearancesState =>
  state.clearances;

const clearancesKeySelector = ({
  clearanceId,
}: CRClearanceBody | CRClearanceSummary): CRClearanceKey => ({
  clearanceId,
});

function mergeClearanceBody(
  lastBody: CRClearanceBody,
  currentBody: CRClearanceBody,
) {
  return currentBody;
}

function combineSummaryBodyClearance(
  summary?: CRClearanceSummary,
  body?: CRClearanceBody,
): CRClearanceSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    rowKey: merge('rowKey'),
    clearanceId: merge('clearanceId'),
    chargeableType: summary?.chargeableType ?? 0,
    clearanceName: merge('clearanceName'),
    clearanceCategory: merge('clearanceCategory'),
    minimumClearanceDisplay: merge('minimumClearanceDisplay'),
    standardClearanceDisplay: merge('standardClearanceDisplay'),
    maximumClearanceDisplay: merge('maximumClearanceDisplay'),
    maxOutOfSquareDisplay: merge('maxOutOfSquareDisplay'),
    tightGapsDisplay: merge('tightGapsDisplay'),
    allowElbows: merge('allowElbows'),
    usesDefault: merge('usesDefault'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'clearances',
  getEndpointClearance,
  clearancesStateSelector,
  sameKeyClearance,
  parseClearanceBody,
  parseClearanceSummary,
  mergeClearanceBody,
  combineSummaryBodyClearance,
);

const clearanceActions: ClearanceActions = actions;
export * from './types';
export {
  clearanceActions,
  reducer as clearancesReducer,
  watches as clearancesWatches,
  clearancesStateSelector,
  clearancesKeySelector,
};
